import { create } from "zustand";
import { api, CreateProjectInput, Project, UpdateProjectPatch } from "../lib/tauri";

interface ProjectState {
  projects: Project[];
  loaded: boolean;
  load: () => Promise<void>;
  create: (input: CreateProjectInput) => Promise<void>;
  update: (id: string, patch: UpdateProjectPatch) => Promise<void>;
}

export const useProjectStore = create<ProjectState>((set, get) => ({
  projects: [],
  loaded: false,
  load: async () => {
    try {
      const projects = (await api.listProjects?.(true)) ?? [];
      set({ projects, loaded: true });
    } catch {
      // PWA など未対応環境: プロジェクトなしで動かす（レーンは未分類のみ表示）
      set({ projects: [], loaded: true });
    }
  },
  create: async (input) => {
    await api.createProject?.(input);
    await get().load();
  },
  update: async (id, patch) => {
    await api.updateProject?.(id, patch);
    await get().load();
  },
}));
